import { useChatAvailability } from "hooks/useChatAvailability";
import { useChatPanelStore } from "stores/chatPanel";
import { ChatContent } from "./ChatContent";
import ChatContextProvider from "./providers/ChatContextProvider";

export const ChatPanel: React.FC = ({}) => {
  const isPanelOpen = useChatPanelStore(store => store.isPanelOpen);
  const isChatAvailable = useChatAvailability();

  if (!isChatAvailable) return null;
  if (!isPanelOpen) return null;

  return (
    <div className="fixed top-[var(--header-height,60px)] right-0 bottom-0 w-chat-panel flex flex-col bg-gray-lightest border-l border-gray overflow-hidden z-20 shadow-lg">
      <ChatContextProvider>
        <ChatContent />
      </ChatContextProvider>
    </div>
  );
};
